export default __webpack_public_path__ + "static/media/casino.bf1a8a94.webp";